/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Partner_Billing_Board_Sync_DaysInputs */



/**
* | output |
* | --- |
* | "Accounting sync · {days}d ago" |
*
* @param {Partner_Billing_Board_Sync_DaysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_sync_days = /** @type {((inputs: Partner_Billing_Board_Sync_DaysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Sync_DaysInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Buchhaltungsabgleich · vor ${i?.days} Tg.`)
	return /** @type {LocalizedString} */ (`Accounting sync · ${i?.days}d ago`)
});